import styles from "./style.module.scss";
import { parseHtml } from "../../../utils/common";
import { Col, Container, Row } from "react-bootstrap";

const CoreBenefits = ({ data }) => {
  return (
    <section className={`common-top ${styles["core-benefits"]} bg-one home-padding-new `} >

      <Container className={styles["container"]}>
        <Row className='justify-content-center'>
          <Col lg={4}>

          <div className={`common-top ${styles["industries-content"]}`}>
              <h2 className="text-black">{data.title}</h2>
            </div>
          </Col>
          <Col lg={8}>
            <div className={styles["boxmain"]}>
              <Row className='justify-content-center'>
                {data?.points?.map((point) => (
                  <Col lg={6} key={point.id}>
                    <div className={`${styles["box"]} text-normal text-black`}>
                      <h5 className="h4 text-black font-semibold">{point?.title}</h5>
                      {parseHtml(point?.text)}
                    </div>
                  </Col>
                ))}
              </Row>
            </div>

          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CoreBenefits;
